export interface ProgressBarConfig {
    id?: string;
    type?: string;
    progressValue?: number;
    subText?: string;
    subTextRight?: boolean;
}

export const DEFAULT_PROGRESS_BAR_CONFIG: ProgressBarConfig = {
    id: '',
    type: '',
    progressValue: 0,
    subText: '',
    subTextRight: false
};